import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { TipiAltroSoggettoComponent } from 'src/app/admin/tipi-altro-soggetto/tipi-altro-soggetto.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => TipoAltroSoggettoPickerComponent) },
  ],
  selector: 'tipo-altro-soggetto-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class TipoAltroSoggettoPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(TipiAltroSoggettoComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
